import { isSuccessStatusCode } from 'owa-http-status-codes';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import { setMergedViewEnabledAccount } from '../mutators/setMergedViewEnabledAccountMutatorActions';
import enableMergedViewAvailabilitySetting from '../services/enableMergedViewAvailabilitySetting';
import { updateMergedViewAvailabilityAccountCompleted } from '../actions/publicActions';

export default async function addMergedViewAvailabilityAccount(primarySmtpAddress: string) {
    let response;
    let updateSuccessful = false;

    response = await enableMergedViewAvailabilitySetting(primarySmtpAddress);

    if (isSuccessStatusCode(response.status)) {
        updateSuccessful = true;
        setMergedViewEnabledAccount(primarySmtpAddress);
    } else {
        let error = response ? await response.text() : 'Unknown';
        trace.warn('addMergedViewAvailabilityAccount failed with Error: ' + error);
    }

    updateMergedViewAvailabilityAccountCompleted(primarySmtpAddress, updateSuccessful);
    logUsage('MergedViewAvailabilityEnabledStatus', {
        status: updateSuccessful,
    });
}
